"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var SButton = (0, _material.styled)('button')({});
var styles = {
  button: {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    color: 'divider'
  },
  active: {
    color: 'additional.red80'
  }
};

var FavouriteButton = function FavouriteButton(_ref) {
  var favourite = _ref.favourite,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(SButton, {
    sx: [styles.button, favourite && styles.active],
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: [favourite ? 'fas' : 'far', 'heart']
  }));
};

var _default = FavouriteButton;
exports.default = _default;